import apiClient from './client'
import { apiEndpoints } from '@/config/api'

/**
 * Cart API Module
 * 
 * Handles all cart-related API operations.
 * All endpoints require authentication.
 */

export const cartApi = {
  /**
   * Get current cart
   * @returns {Promise} Cart data with items
   */
  async getCart() {
    const response = await apiClient.get(apiEndpoints.cart.show)
    return response.data
  },

  /**
   * Add item to cart
   * @param {Object} item - Item to add
   * @param {number} item.product_id - Product ID
   * @param {number} item.variant_id - Variant ID (optional)
   * @param {number} item.quantity - Quantity
   * @returns {Promise} Updated cart
   */
  async addItem(item) {
    const response = await apiClient.post(apiEndpoints.cart.addItem, item)
    return response.data
  },

  /**
   * Update cart item quantity
   * @param {number} itemId - Cart item ID
   * @param {number} quantity - New quantity (0 removes item)
   * @returns {Promise} Updated cart
   */
  async updateItem(itemId, quantity) {
    const response = await apiClient.put(apiEndpoints.cart.updateItem(itemId), { quantity })
    return response.data
  },

  /**
   * Remove item from cart
   * @param {number} itemId - Cart item ID
   * @returns {Promise} Updated cart
   */
  async removeItem(itemId) {
    const response = await apiClient.delete(apiEndpoints.cart.removeItem(itemId))
    return response.data
  },

  /**
   * Clear entire cart
   * @returns {Promise} Empty cart
   */
  async clearCart() {
    const response = await apiClient.delete(apiEndpoints.cart.clear)
    return response.data
  },
}

export default cartApi
